import React, { useMemo } from "react";
import { FormattedMessage, IntlShape } from "react-intl";
import moment from "moment";
import DatePickerGroup from "../../../witadmin/CRUD/Common/DatePickerGroup";
import { messages } from "./messages";
import { Container, DatePickerContainer } from "./styles";
import { ErrorFieldMessage } from "../ErrorFieldMessage";

export type RangeDateType = {
  startDate: string | null;
  endDate: string | null;
};

type OpenBookingProps = {
  field: Record<string, any>;
  intl: IntlShape;
  disabled: boolean;
  defaultValues: RangeDateType;
  onChange: (rangeDate: RangeDateType) => void;
};

export const OpenBooking = ({ field, disabled, defaultValues, onChange }: OpenBookingProps) => {
  const handleOnChangeStartDate = ({ value }: { value: string }) => {
    onChange({ ...defaultValues, startDate: value });
  };

  const handleOnChangeEndDate = ({ value }: { value: string }) => {
    onChange({ ...defaultValues, endDate: value });
  };

  const isInvalidForm = useMemo(() => {
    const isEndDateBeforeStartDate = moment(defaultValues.endDate).isBefore(
      defaultValues.startDate
    );
    return !disabled && defaultValues && defaultValues.endDate && isEndDateBeforeStartDate;
  }, [disabled, defaultValues]);

  return (
    <Container>
      <DatePickerContainer>
        <FormattedMessage {...messages.startBookable} />
        <DatePickerGroup
          disabled={disabled}
          value={defaultValues && defaultValues.startDate}
          isClearable={false}
          field={{
            ...field,
            fieldName: "startDate",
            displayName: <FormattedMessage {...messages.startBookable} />,
            selectsStart: true,
          }}
          formValues={{
            startDate: defaultValues && defaultValues.startDate,
            endDate: defaultValues && defaultValues.endDate,
          }}
          onChange={handleOnChangeStartDate}
        />

        <>
          <FormattedMessage {...messages.endBookable} />
          <DatePickerGroup
            disabled={disabled}
            value={defaultValues && defaultValues.endDate}
            isClearable={false}
            field={{
              ...field,
              fieldName: "endDate",
              displayName: <FormattedMessage {...messages.endBookable} />,
              selectsEnd: true,
            }}
            formValues={{
              startDate: defaultValues && defaultValues.startDate,
              endDate: defaultValues && defaultValues.endDate,
            }}
            onChange={handleOnChangeEndDate}
          />
        </>
      </DatePickerContainer>
      {isInvalidForm && <ErrorFieldMessage {...messages.endDateAfterStart} />}
    </Container>
  );
};
